import { orchestrator } from 'satcheljs';
import { updateCalendarIds } from 'owa-agenda-events-list';
import {
    selectedCalendarsUpdated,
    getSelectedCalendarsFlatList,
} from 'owa-calendar-module-selected-calendars-user-config';
import { AgendaScenarioId } from '../constants';

orchestrator(selectedCalendarsUpdated, actionMessage => {
    updateCalendarIds(getSelectedCalendarsFlatList(), AgendaScenarioId);
});
